import type { Router } from 'vue-router'

import { useUserStore } from '@blueprint/frontend-basics'

import { APP_ADMIN_REALM_ROLE } from '@/constants/auth.constants.ts'
import { AppRoutes } from '@/enums/app-routes.enum.ts'
import { useServiceStore } from '@/stores/service.store.ts'

export async function ensureAdminAccess(
  router: Router,
  lang: string,
): Promise<boolean> {
  const userStore = useUserStore()
  const serviceStore = useServiceStore()
  const authService = serviceStore.authService

  await userStore.awaitInit()

  if (!authService.isAuthenticated()) {
    void authService.startLoginProcess(window.location.href)
    return false
  }

  if (!authService.keycloak.hasRealmRole(APP_ADMIN_REALM_ROLE)) {
    await router.push({
      name: AppRoutes.ACCESS_DENIED,
      params: { lang },
    })
    return false
  }

  return true
}
